import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAllSet = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-mid, #A0BCEC)",
			d: "m117.04 99.94-5.75-3.42a29 29 0 0 1 6.45-4.31q.15 3.92-.7 7.73"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-mid, #A0BCEC)",
			d: "M112.03 107.05a2.67 2.67 0 1 1-4.6-2.74 2.67 2.67 0 0 1 4.6 2.74"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-mid, #A0BCEC)",
			d: "m101.78 106.47-51.06 9.88 22.5-20.64z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-mid, #A0BCEC)",
			d: "m83.67 119.66-11.32 2.2 2.55 13.11h11.74z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue-muted, #6A89C1)",
			d: "M159.67 88.17q-.44-.03-.87.05a2.66 2.66 0 0 0-1.68-4.52 2.8 2.8 0 0 0-1.57.29 2.5 2.5 0 0 0 .34-2.26 2.7 2.7 0 0 0-2.35-1.88 2.6 2.6 0 0 0-1.62.32q.3-.48.36-1.06a2.7 2.7 0 0 0-2.46-2.91 2.8 2.8 0 0 0-2.48 1.06l-3.27 6.69q1.24 1.43 2.7 2.63c-2.08 4.06-.71 4.87.7 3.72 2.67-2.15 4.92 1.33.2 4.37q.05 5.17 1.05 10.25s.11-9.64 11.21-11.53a2.7 2.7 0 0 0 2.19-2.35 2.66 2.66 0 0 0-2.45-2.87"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M136.87 100.59q.03.34.15.66c.44 1.26 3.21 2.38 5.78 3.08q1.76-1.82 2.88-4.1c-4.27 1.62-8.4 2.59-8.81.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M26.97 33.68a1.36 1.36 0 1 0 0 2.72 1.36 1.36 0 0 0 0-2.72"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M66.33 38.79a1.02 1.02 0 1 1-.52-1.97 1.02 1.02 0 0 1 .52 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "m78.38 72.38-2.23-14.37c.47 3.35.3 6.77-.5 10.06a36 36 0 0 0 2.73 4.31"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "m104.13 56.14 1.4-1.6c-1.18-.1-1.73.56-1.4 1.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M113.09 61.59q-.24.43-.53.85a1.13 1.13 0 0 0 1.28-.87z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-blue-muted, #6A89C1)",
			d: "M74.73 28.52a4.47 4.47 0 0 0-2.9-5.23 4.48 4.48 0 0 0-5.4-5.75 4.4 4.4 0 0 0-3.33-3.38l-.28-.08a4.5 4.5 0 0 0-4.39 1.42 4.46 4.46 0 0 0-7.48 2.45 4.44 4.44 0 0 0-4.77 6.32 4.46 4.46 0 0 0-.9 7.88 4.45 4.45 0 0 0 3.5 7.01 4.47 4.47 0 0 0 6.9 3.92 4.4 4.4 0 0 0 3.11 2.29c1.21-1.52 1.91-3.79 1.1-7.47l-.02-.08-2.2.59c-1.19.32-2.62-1.23-3.23-3.44-.58-2.23-.1-4.27 1.08-4.6l1.14-.3c-.42-2.45 1.2-4.59 4.18-5.44a5.2 5.2 0 0 1 6.12 2.87c.93.08 2.18 1.52 2.7 3.54a6 6 0 0 1 .04 3.35 1.8 1.8 0 0 1-.94 1.19l.1.68c.33 3.12-.8 4.6-3.3 4.4l-.5-.05q-.02 1.5.64 2.85a4.45 4.45 0 0 0 4.34-4.95 4.46 4.46 0 0 0 2.97-7.37 4.6 4.6 0 0 0 1.72-2.62"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M61 25.12c-2.7.77-4.14 2.58-3.8 4.76l1.06-.28q.42-.11.82.05c1.4-.52 4.84-1.92 7.3-2.08A4.6 4.6 0 0 0 61 25.12"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "m141.12 129.05-3.17 25.15h-4.18q1.51-1.76 2.2-3.95z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M133.1 194.53h-2.3l-.8-13.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M81.13 181.1h-5.85v-5.84h5.85z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M65.26 42.2q-.17-.8-.21-1.64-.87-.14-1.7-.41l2.15 2.83z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint0_linear_4006_3474)",
			strokeLinejoin: "round",
			d: "M74.73 28.52a4.47 4.47 0 0 0-2.9-5.23 4.48 4.48 0 0 0-5.4-5.75 4.4 4.4 0 0 0-3.33-3.38l-.28-.08a4.5 4.5 0 0 0-4.39 1.42 4.46 4.46 0 0 0-7.48 2.45 4.44 4.44 0 0 0-4.77 6.32 4.46 4.46 0 0 0-.9 7.88 4.45 4.45 0 0 0 3.5 7.01 4.47 4.47 0 0 0 6.9 3.92 4.4 4.4 0 0 0 3.11 2.29c1.21-1.52 1.91-3.79 1.1-7.47l-.02-.08-2.2.59c-1.19.32-2.62-1.23-3.23-3.44-.58-2.23-.1-4.27 1.08-4.6l1.14-.3c-.42-2.45 1.2-4.59 4.18-5.44a5.2 5.2 0 0 1 6.12 2.87c.93.08 2.18 1.52 2.7 3.54a6 6 0 0 1 .04 3.35 1.8 1.8 0 0 1-.94 1.19l.1.68c.33 3.12-.8 4.6-3.3 4.4l-.5-.05q-.02 1.5.64 2.85a4.45 4.45 0 0 0 4.34-4.95 4.46 4.46 0 0 0 2.97-7.37 4.6 4.6 0 0 0 1.72-2.62Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint1_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M162.13 91.04a2.7 2.7 0 0 1-2.2 2.34c-11.06 2.04-11.2 11.54-11.2 11.54a57 57 0 0 1-1.06-10.25c4.72-3.05 2.47-6.53-.2-4.37-1.41 1.15-2.77.34-.69-3.72q-1.46-1.2-2.7-2.63l3.27-6.7a2.79 2.79 0 0 1 4.82.81q.15.52.11 1.05-.05.57-.36 1.06a2.77 2.77 0 0 1 4.08 2.6q-.07.67-.45 1.22a2.8 2.8 0 0 1 1.57-.29 2.66 2.66 0 0 1 1.68 4.52q.44-.09.87-.06a2.65 2.65 0 0 1 2.46 2.88"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint2_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M136.89 100.67c.5 2.12 4.57 1.16 8.79-.44-.74 1.5-1.7 2.9-2.87 4.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint3_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m117 99.94-5.71-3.42"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint4_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M100.33 111.51a48 48 0 0 1 10.94-15 29 29 0 0 1 6.47-4.3q.14 3.92-.74 7.73a47 47 0 0 1-7.66 16.43"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint5_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M108.36 107.98a2.68 2.68 0 1 1 2.74-4.6 2.68 2.68 0 0 1-2.74 4.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint6_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M94.83 107.8a30 30 0 0 0-2.7 3.03c3.02-1.41 5.99-2.4 9.48-1.89"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint7_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M106.2 101.93c-2.9.43-5.65 1.52-8.07 3.17"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint8_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M112.69 118.24a14 14 0 0 0-1.97-3.87"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint9_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M114.71 107a19.4 19.4 0 0 1 .91 9.73"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint10_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M74.25 29.75H97.5a3.7 3.7 0 0 1 3.68 3.68v25.38"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint11_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M101.2 79.9v5.4A3.7 3.7 0 0 1 97.5 89H25.37a3.7 3.7 0 0 1-3.68-3.68V33.43a3.7 3.7 0 0 1 3.68-3.68h18.11"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint12_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M48.9 40.3H21.69"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint13_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M101.2 40.3H69.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint14_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M28.34 35.04a1.36 1.36 0 1 1-2.73 0 1.36 1.36 0 0 1 2.73 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint15_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M32.44 35.04a1.36 1.36 0 1 1-2.72 0 1.36 1.36 0 0 1 2.72 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint16_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M36.56 35.04a1.36 1.36 0 1 1-2.72 0 1.36 1.36 0 0 1 2.72 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint17_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m143.6 61.17-7.07 2.48 2.74-6.22a11.7 11.7 0 0 1-2.57-7.34c.1-7.49 7.65-13.47 16.9-13.38s16.68 6.22 16.6 13.68c-.09 7.49-7.66 13.48-16.9 13.4-3.41 0-6.76-.9-9.7-2.62"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent-bright, #A3E27D)",
			stroke: "url(#all-set_svg__paint18_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M153.35 42.19a63 63 0 0 1-6.65 3.18v2.89a11.3 11.3 0 0 0 6.7 10.04 11.3 11.3 0 0 0 6.63-10.08v-2.9a43 43 0 0 1-6.68-3.13"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint19_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m150.73 48.86 2.64 3.69 2.61-4.61"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint20_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m58.2 114.9 3.88 20.07"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint21_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m95.35 113.39-.7-3.62"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint22_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m74.9 134.97-2.55-13.12 11.32-2.19 2.97 15.31"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint23_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m101.78 106.47-51.06 9.88 22.5-20.64z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint24_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M121.6 159.65v34.88H62.08v-59.56h58.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint25_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m62.08 134.97-15.39 15.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint26_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M72.2 190.08h-5.84v-5.84h5.84z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint27_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M81.12 190.1h-5.84v-5.86h5.84z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint28_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M72.21 181.1h-5.84v-5.84h5.84z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint29_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M81.13 181.1h-5.85v-5.84h5.85z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint30_linear_4006_3474)",
			strokeLinejoin: "round",
			d: "M81.13 181.1h-5.85v-5.84h5.85z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint31_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M58.8 45.38a10 10 0 0 1-4.68 2.97C40.06 52.64 36.77 80.2 35.22 89"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint32_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M61.49 36.5a9 9 0 0 0 3.54 1.17"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint33_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M58.8 37.08a1.8 1.8 0 0 1-1.14 1.3c-1.2.34-2.64-1.22-3.24-3.43-.91-3.39.71-5.83 2.7-4.03a6.8 6.8 0 0 1 1.67 6.16"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint34_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m55.5 30.35 2.76-.76c1.42-.37 2.77 1.69 3.23 3.44.6 2.22.12 4.28-1.07 4.6l-2.74.75h-.02"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint35_linear_4006_3474)",
			strokeLinejoin: "round",
			d: "M59.1 29.64a32 32 0 0 1 7.03-2.05c1.05 2.39 2.49 6.02 2.72 8.62.36 3.3-.95 4.79-3.8 4.35a5.5 5.5 0 0 0 2.06 4.54c0 .76-8.04 1-8.32.28a7.4 7.4 0 0 0 1.37-5.83q-.09-.88-.31-1.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint36_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M65.8 36.82a1.02 1.02 0 1 1 .53 1.96 1.02 1.02 0 0 1-.53-1.96"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint37_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M92.46 69.87c-13.5-19.5-15.61-21.78-20.34-22.77-1.8-.3-3.52-.98-5.03-2.02"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint38_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m65.5 42.99-2.15-2.84q.83.28 1.7.42"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint39_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M53.1 68.13c.44 3.65.95 8.28.95 10.02 4.68 1.26 14.8 1.45 19.75 0 .66-9.51 3.6-10.57 2.25-21.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint40_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m47.71 89 6.32-24.52"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint41_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M54.06 78.17a27.5 27.5 0 0 0-6.03 9.71"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint42_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M73.82 78.17S73.78 85 75.56 89"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint43_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M113.63 62.04C105.15 74.9 98.07 89.53 88.08 82.1a45 45 0 0 1-12.43-14.05"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint44_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m76.15 58 2.23 14.38"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint45_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M105.52 54.53c-1.17-.1-1.7.56-1.4 1.61.63 2.2 5.84 6.23 8.44 6.3a1.14 1.14 0 0 0 1.28-.87"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint46_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M90.95 71.8 104.2 55"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint47_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M117.17 59.03c-1.76-.06-1.91-2.2-.2-2.25 1.26-.04 2.17-.03 3.17-.03 1.68 0 1.77 2.22.38 2.36q-1.68.04-3.35-.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint48_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M117.32 61.24c-1.7-.18-1.7-2.24-.06-2.18 1.23.04 1.37.01 2.35.1 1.63.12 1.57 2.28.22 2.3q-1.27 0-2.5-.22"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint49_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M111.48 58.13c2.25.37 4.23-2.8 3.14-5.22-.15-1.81-.15-1.9-.55-4.9-.4-2.95-2.04-3.16-2-2.46q-.15 2.97-1.1 5.79c-.62 1.23-3.02 1.46-3.93 1.95a13 13 0 0 0-2.91 2.85"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint50_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m120.02 61.45-6.93.13-.53.86"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint51_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M117.38 54.57c-1.7.16-2.1-1.88-.47-2.13 1.2-.2 2.08-.29 3.04-.4 1.63-.2 1.97 1.97.66 2.23-.81.16-1.68.16-3.23.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint52_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M117.1 56.76c-1.7.02-1.95-2.04-.3-2.17 1.23-.1 3.02-.15 4-.19 1.63-.06 1.82 2.1.48 2.27-.82.1-2.64.08-4.19.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint53_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M114.35 50.24c.2 2.27.3 2.1 5.6 1.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint54_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M148.87 105.65q.55 1.73 1.16 3.67a76 76 0 0 1 2.08 36.09c-.14.74-1.4 8.8-1.4 8.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint55_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M97.83 165.18c-4.4.36-10.25.75-14.12.7-3.3-.04-6.7-.02-9.98-.34-3.33-.32-3.7-1.8-.74-2.17a40 40 0 0 0 4.27-.93 53 53 0 0 1-7.4-.45c-3.4-.53-3.54-2.55-.5-2.59 1.02-.01 3.61-.2 6.35-.57q-3.83-.46-7.58-1.43c-3.3-.99-3.21-3.02-.19-2.63q4.49.34 8.98.11a42 42 0 0 1-6.52-1.8c-3.27-1.24-2.84-2.98.19-2.55 4.3.76 8.67.97 13.02.65-8.24-6.34-7.16-8.43.48-4.56a25 25 0 0 0 9.68 2.29"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint56_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M141.07 107.05c-20.23 4.5-13.73 9.2-21.95 34.14l-25.3 6.7q-.29 4.37.68 8.63a29 29 0 0 0 4.01 9.72l29.64-8.47a11.6 11.6 0 0 0 7.83-7.52l5.14-21.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint57_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M79.62 155.32c-.71-.1-1.66-.25-2.7-.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint58_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M86.09 150.9q-1.26.2-2.48.28"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint59_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M80.14 159.34c-.87-.07-2.54-.26-4.43-.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint60_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M77.24 162.44c1.33 0 2.48-.02 3.22-.07"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint61_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M101.91 145.75a53 53 0 0 0 4.79 18.15"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint62_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M163.54 194.53c-3.55-25.74-12.4-31.03-12.83-40.33h-16.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint63_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M16.4 117.58a1.9 1.9 0 1 1-3.72.85 1.9 1.9 0 0 1 3.73-.85"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint64_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M179.93 147.89v14.87"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint65_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M187.36 155.32h-14.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint66_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M68.76 35.53a2.5 2.5 0 0 0 1.13-1.96c.4-2.91-1.74-6.47-3.2-6.09l-.53.19"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint67_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m58.62 45.57 2.82 4.88 2.98-4.73 4.31 3.9-.22-3.65"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint68_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M54.49 48.23c2.83 4.02 15.44 8.07 17.63-1.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint69_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m133.1 194.53-3.1-13.6-2.7-1.78"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint70_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m141.12 129.06-3.2 25.14"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint71_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m130.8 194.53-.8-13.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint72_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M147.46 90.3c-1.42 1.16-2.78.34-.7-3.72a21 21 0 0 1-2.7-2.63c-4.6 7.95-6.56 12.2-7.07 14.78-.61 3.1.54 4.16 5.82 5.6q-.4.75-.68 1.55a1.8 1.8 0 0 1-1.06 1.17l1.5-.32c1.88-.36 4.1-.72 6.3-1.08a56 56 0 0 1-1.22-10.98c4.72-3.04 2.47-6.52-.2-4.37"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint73_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m118.77 129.47-3.62 5.52"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint74_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m114.92 135-1-6.81-3.14-.83-.78-2.65-1.94 1.93-3.3-.87-1.54 2.15-1.04-7.39-2.8 3.82"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint75_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M124.94 118.36a9.6 9.6 0 0 0-10.93-.9l-2.98 1.77-1.76-3a9.53 9.53 0 0 0-15.85-.94 9.5 9.5 0 0 0-.62 10.6l5.33 9.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint76_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M128.38 5.48v2.39"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint77_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M133.03 10.13h-2.39"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint78_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M128.38 14.78v-2.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint79_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M123.73 10.13h2.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#all-set_svg__paint80_linear_4006_3474)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M130.64 10.13a2.26 2.26 0 0 1-2.26-2.27 2.25 2.25 0 0 1-2.26 2.26 2.25 2.25 0 0 1 2.26 2.26 2.25 2.25 0 0 1 2.26-2.25"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint0_linear_4006_3474",
				x1: 59.066,
				x2: 58.316,
				y1: 40.695,
				y2: 19.665,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint1_linear_4006_3474",
				x1: 153.107,
				x2: 152.013,
				y1: 100.642,
				y2: 81.439,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint2_linear_4006_3474",
				x1: 141.282,
				x2: 141.236,
				y1: 103.719,
				y2: 100.969,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint3_linear_4006_3474",
				x1: 114.145,
				x2: 114.096,
				y1: 99.434,
				y2: 97.141,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint4_linear_4006_3474",
				x1: 109.041,
				x2: 108.239,
				y1: 112.779,
				y2: 96.619,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint5_linear_4006_3474",
				x1: 109.729,
				x2: 109.6,
				y1: 107.559,
				y2: 103.978,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint6_linear_4006_3474",
				x1: 96.868,
				x2: 96.845,
				y1: 110.383,
				y2: 108.355,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint7_linear_4006_3474",
				x1: 102.169,
				x2: 102.139,
				y1: 104.632,
				y2: 102.503,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint8_linear_4006_3474",
				x1: 111.706,
				x2: 111.524,
				y1: 117.667,
				y2: 115.081,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint9_linear_4006_3474",
				x1: 115.292,
				x2: 113.494,
				y1: 115.283,
				y2: 109.296,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint10_linear_4006_3474",
				x1: 87.721,
				x2: 86.97,
				y1: 54.486,
				y2: 35.034,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint11_linear_4006_3474",
				x1: 61.441,
				x2: 60.382,
				y1: 80.179,
				y2: 40.49,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint12_linear_4006_3474",
				x1: 35.295,
				x2: 35.294,
				y1: 41.15,
				y2: 40.479,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint13_linear_4006_3474",
				x1: 85.566,
				x2: 85.565,
				y1: 41.15,
				y2: 40.479,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint14_linear_4006_3474",
				x1: 26.974,
				x2: 26.909,
				y1: 35.999,
				y2: 34.176,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint15_linear_4006_3474",
				x1: 31.078,
				x2: 31.013,
				y1: 35.999,
				y2: 34.176,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint16_linear_4006_3474",
				x1: 35.198,
				x2: 35.132,
				y1: 35.999,
				y2: 34.176,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint17_linear_4006_3474",
				x1: 153.363,
				x2: 152.84,
				y1: 59.768,
				y2: 41.618,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint18_linear_4006_3474",
				x1: 153.364,
				x2: 152.897,
				y1: 55.903,
				y2: 45.123,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint19_linear_4006_3474",
				x1: 153.354,
				x2: 153.257,
				y1: 51.862,
				y2: 48.773,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint20_linear_4006_3474",
				x1: 60.143,
				x2: 57.728,
				y1: 131.988,
				y2: 118.975,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint21_linear_4006_3474",
				x1: 95.004,
				x2: 94.571,
				y1: 112.848,
				y2: 110.507,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint22_linear_4006_3474",
				x1: 79.492,
				x2: 79.099,
				y1: 132.697,
				y2: 122.444,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint23_linear_4006_3474",
				x1: 76.25,
				x2: 76.05,
				y1: 113.282,
				y2: 99.443,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint24_linear_4006_3474",
				x1: 91.842,
				x2: 90.413,
				y1: 185.668,
				y2: 145.791,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint25_linear_4006_3474",
				x1: 54.386,
				x2: 54.012,
				y1: 148.171,
				y2: 137.79,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint26_linear_4006_3474",
				x1: 69.284,
				x2: 69.144,
				y1: 189.214,
				y2: 185.302,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint27_linear_4006_3474",
				x1: 78.197,
				x2: 78.057,
				y1: 189.221,
				y2: 185.303,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint28_linear_4006_3474",
				x1: 69.293,
				x2: 69.153,
				y1: 180.234,
				y2: 176.322,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint29_linear_4006_3474",
				x1: 78.202,
				x2: 78.062,
				y1: 180.234,
				y2: 176.322,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint30_linear_4006_3474",
				x1: 78.202,
				x2: 78.062,
				y1: 180.234,
				y2: 176.322,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint31_linear_4006_3474",
				x1: 47.004,
				x2: 45.075,
				y1: 82.511,
				y2: 53.396,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint32_linear_4006_3474",
				x1: 63.259,
				x2: 63.249,
				y1: 37.495,
				y2: 36.706,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint33_linear_4006_3474",
				x1: 56.564,
				x2: 56.235,
				y1: 37.225,
				y2: 31.8,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint34_linear_4006_3474",
				x1: 58.625,
				x2: 58.325,
				y1: 37.07,
				y2: 31.161,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint35_linear_4006_3474",
				x1: 63.849,
				x2: 63.065,
				y1: 43.102,
				y2: 30.936,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint36_linear_4006_3474",
				x1: 66.069,
				x2: 66.02,
				y1: 38.516,
				y2: 37.153,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint37_linear_4006_3474",
				x1: 79.776,
				x2: 79.195,
				y1: 66.179,
				y2: 49.582,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint38_linear_4006_3474",
				x1: 64.425,
				x2: 64.335,
				y1: 42.565,
				y2: 40.668,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint39_linear_4006_3474",
				x1: 64.75,
				x2: 64.247,
				y1: 75.881,
				y2: 61.079,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint40_linear_4006_3474",
				x1: 50.87,
				x2: 48.627,
				y1: 85.35,
				y2: 69.222,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint41_linear_4006_3474",
				x1: 51.05,
				x2: 50.675,
				y1: 86.437,
				y2: 79.943,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint42_linear_4006_3474",
				x1: 74.69,
				x2: 73.147,
				y1: 87.386,
				y2: 80.468,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint43_linear_4006_3474",
				x1: 94.643,
				x2: 94.335,
				y1: 80.825,
				y2: 66.037,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint44_linear_4006_3474",
				x1: 77.261,
				x2: 75.146,
				y1: 70.24,
				y2: 61.083,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint45_linear_4006_3474",
				x1: 108.942,
				x2: 108.789,
				y1: 61.271,
				y2: 55.962,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint46_linear_4006_3474",
				x1: 97.575,
				x2: 97.065,
				y1: 69.297,
				y2: 58.064,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint47_linear_4006_3474",
				x1: 118.627,
				x2: 118.603,
				y1: 58.771,
				y2: 57.176,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint48_linear_4006_3474",
				x1: 118.437,
				x2: 118.408,
				y1: 61.104,
				y2: 59.49,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint49_linear_4006_3474",
				x1: 109.527,
				x2: 109.156,
				y1: 56.232,
				y2: 47.573,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint50_linear_4006_3474",
				x1: 116.291,
				x2: 116.288,
				y1: 62.289,
				y2: 61.63,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint51_linear_4006_3474",
				x1: 118.642,
				x2: 118.614,
				y1: 54.2,
				y2: 52.488,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint52_linear_4006_3474",
				x1: 118.923,
				x2: 118.903,
				y1: 56.413,
				y2: 54.828,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint53_linear_4006_3474",
				x1: 117.151,
				x2: 117.134,
				y1: 51.918,
				y2: 50.598,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint54_linear_4006_3474",
				x1: 151.115,
				x2: 140.154,
				y1: 146.98,
				y2: 118.672,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint55_linear_4006_3474",
				x1: 81.746,
				x2: 81.41,
				y1: 162.731,
				y2: 148.516,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint56_linear_4006_3474",
				x1: 117.438,
				x2: 115.666,
				y1: 157.44,
				y2: 117.831,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint57_linear_4006_3474",
				x1: 78.273,
				x2: 78.271,
				y1: 155.249,
				y2: 154.944,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint58_linear_4006_3474",
				x1: 84.852,
				x2: 84.851,
				y1: 151.134,
				y2: 150.944,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint59_linear_4006_3474",
				x1: 77.923,
				x2: 77.922,
				y1: 159.267,
				y2: 158.925,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint60_linear_4006_3474",
				x1: 78.849,
				x2: 78.849,
				y1: 162.432,
				y2: 162.381,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint61_linear_4006_3474",
				x1: 104.305,
				x2: 102.681,
				y1: 161.2,
				y2: 149.251,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint62_linear_4006_3474",
				x1: 148.675,
				x2: 147.365,
				y1: 188.528,
				y2: 161.554,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint63_linear_4006_3474",
				x1: 14.544,
				x2: 14.452,
				y1: 119.35,
				y2: 116.791,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint64_linear_4006_3474",
				x1: 180.425,
				x2: 176.285,
				y1: 160.552,
				y2: 152.782,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint65_linear_4006_3474",
				x1: 179.915,
				x2: 179.914,
				y1: 156.176,
				y2: 155.506,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint66_linear_4006_3474",
				x1: 68.05,
				x2: 67.638,
				y1: 34.329,
				y2: 28.945,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint67_linear_4006_3474",
				x1: 63.678,
				x2: 63.621,
				y1: 49.725,
				y2: 46.456,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint68_linear_4006_3474",
				x1: 63.304,
				x2: 63.262,
				y1: 51.86,
				y2: 48.129,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint69_linear_4006_3474",
				x1: 130.205,
				x2: 129.236,
				y1: 192.239,
				y2: 182.026,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint70_linear_4006_3474",
				x1: 139.525,
				x2: 135.123,
				y1: 150.461,
				y2: 134.843,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint71_linear_4006_3474",
				x1: 130.403,
				x2: 126.342,
				y1: 192.504,
				y2: 185.88,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint72_linear_4006_3474",
				x1: 143.618,
				x2: 142.676,
				y1: 103.616,
				y2: 88.183,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint73_linear_4006_3474",
				x1: 116.958,
				x2: 116.756,
				y1: 134.172,
				y2: 130.483,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint74_linear_4006_3474",
				x1: 107.15,
				x2: 106.827,
				y1: 132.842,
				y2: 123.156,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint75_linear_4006_3474",
				x1: 108.215,
				x2: 107.819,
				y1: 131.5,
				y2: 115.761,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint76_linear_4006_3474",
				x1: 128.88,
				x2: 128.744,
				y1: 7.51,
				y2: 5.919,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint77_linear_4006_3474",
				x1: 131.836,
				x2: 131.826,
				y1: 10.977,
				y2: 10.306,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint78_linear_4006_3474",
				x1: 128.88,
				x2: 128.744,
				y1: 14.421,
				y2: 12.83,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint79_linear_4006_3474",
				x1: 124.926,
				x2: 124.916,
				y1: 10.977,
				y2: 10.306,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "all-set_svg__paint80_linear_4006_3474",
				x1: 128.381,
				x2: 128.273,
				y1: 11.712,
				y2: 8.684,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from-deep, #62884B)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			})
		] })
	]
});
export default SvgAllSet;
